export default {
  SALES_DELIVERIES_LIST: "List of deliveries",
  ADD_SALES_DELIVERY: "Add a delivery",
  ADD_SALES_DELIVERY_ITEM: "Line",
  SALES_DELIVERY_ADDED: "Added delivery",
  OWNER: "Owner",
  EDIT_SALES_DELIVERY: "Modify a delivery",
  SALES_DELIVERY_UPDATED: "Update delivery",
  BILLING_ADDRESS: "Billing address",
  EXPIRATION_TIME: "Deadline",
  ITEM_TYPE: "type",
  SELECT_PRODUCTS: "Choose a product",
  SELECT_SUBSCRIPTIONS: "Choose a registration",
  SELECT_PACKAGES: "Choose a package",
  DELETE_SALES_DELIVERY_ITEM: "Delete the line",
  UPDATE_SALES_DELIVERY_ITEM: "Edit the line",
  SALES_DELIVERY_ITEM_DELETED: "Deleted line",
  SALES_DELIVERY_ITEM_ADDED: "Line added",
  SALES_DELIVERY_ITEM_EDITED: "Modified line",
  SEND: "Send",
  CANCEL: "Cancel",
  REFUND: "Repay",
  ADD_PAYMENT: "Add a payment",
  SALES_DELIVERY_SENT: "Delivery sent",
  SELECT_USERS: "Choose the user",
  SELECT_CUSTOMERS: "Choose",
  SELECT_ORGANIZATIONS: "Choose",
  SELECT_SUPPLIERS: "Choose the supplier",
  DELETE_THIS_SALES_DELIVERY: "Delete this delivery?",
  SALES_DELIVERY_DELETED: "Delivery deleted",
  CANCEL_SALES_DELIVERY_QUESTION: "Cancel delivery?",
  SALES_DELIVERY_CANCELED: "Canceled delivery",
  RECIPIENT: "RECIPIENT",
  ISSUER: "Issuer",
  VALIDATE: "To validate",
  SALES_DELIVERY_VALIDATED: "Validated delivery",
  VIEW_ORDER: "See the order",
  VIEW_SALES_DELIVERY: "Sale delivery",
  VALIDATE_DELIVERY: "Validate delivery",
  SALES_ORDER_DELIVERY_ADDED: "Added delivery",

  CREATED_AT: "Created at",
};
